import React, { Component } from 'react';
import {connect} from 'react-redux';
import {  getSecSubOptionDataByOptionId, UpdateSecSubOption, emptyDemographicsSubOption } from '../../actions/demographics';
import EditSecSubOption from '../../components/demographics/editSecSubOption';

class EditDemographicsSecSubOption extends Component {
  constructor(props){
    super(props)

    this.queryString = window.location.href;

    if (this.queryString !== "") {
        this.sec_sub_option_id = this.queryString.split("&ssop:")[1]
    }

    this.state={
        sec_sub_option_id : this.sec_sub_option_id
    };
    this.UpdateSecSubOption = this.UpdateSecSubOption.bind(this);
    this.emptyDemographicsSecSubOption = this.emptyDemographicsSecSubOption.bind(this);
  }

 

  componentDidMount(){
    if(this.state.sec_sub_option_id){
       this.props.dispatch( getSecSubOptionDataByOptionId(this.state.sec_sub_option_id));
    }
  }

  UpdateSecSubOption( data){
    this.props.dispatch(UpdateSecSubOption(data));
  }

  emptyDemographicsSecSubOption(){
      this.props.dispatch(emptyDemographicsSubOption());
  }
  
  render(){

   
    let showEditDemographicsCategoriesSubOptionView ="";
    if(this.props.showEditSecSubOption){
         showEditDemographicsCategoriesSubOptionView = <EditSecSubOption
         showEditSecSubOption = {this.props.showEditSecSubOption}
         secSubOptionEditData = {this.props.secSubOptionEditData}

         UpdateSecSubOption = {this.UpdateSecSubOption}

         secSubOptionUpdateSuccess = {this.props.secSubOptionUpdateSuccess}
         secSubOptionUpdateSuccessMessage = {this.props.secSubOptionUpdateSuccessMessage}
         secSubOptionUpdateFailMessage = {this.props.secSubOptionUpdateFailMessage}

         emptyDemographicsSecSubOption = {this.emptyDemographicsSecSubOption}
        />
    }
    
      
    return (
        <div> 
             {showEditDemographicsCategoriesSubOptionView}
        </div>
    );
  }
}

const  mapStateToProps =(state) =>{
  return {
    showEditSecSubOption : state.demographics.showEditSecSubOption,
    secSubOptionEditData : state.demographics.secSubOptionEditData,
   
    secSubOptionUpdateSuccess : state.demographics.secSubOptionUpdateSuccess,
    secSubOptionUpdateSuccessMessage : state.demographics.secSubOptionUpdateSuccessMessage,
    secSubOptionUpdateFailMessage : state.demographics.secSubOptionUpdateFailMessage,

  }
}

export default connect(mapStateToProps)(EditDemographicsSecSubOption);



// WEBPACK FOOTER //
// ./src/pages/demographics/editSecSubOption.js